import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  static environmentConfig: any = {};

  constructor() {}
}
